import { useState } from 'react';

import { AddAccount } from '@/features/account-actions';

import { useVabsAccountsStore } from '@/entities/currency-account';
import {
  useAccountStore,
  useTotalBalanceStore,
} from '@/entities/currency-account/model/store';

import { AllAccounts, ChevronIcon } from '@/shared/assets';
import { Button, Heading, Typography } from '@/shared/ui';

import { AssetsItem } from './assets-item';
import { OthersAssetsItem } from './others-assets-item';
import { TotalAssetsModal } from './total-assets-modal';

const AssetsWidgetHeader: React.FC<{
  onClick?: VoidFunction;
  balance: string;
}> = ({ onClick, balance }) => {
  return (
    <div className="flex justify-between p-5 pb-6" onClick={onClick}>
      <div className="flex flex-col gap-y-2">
        <div className="group flex items-center gap-x-1">
          <Typography
            variant="14-m"
            className="text-center transition-colors duration-200 ease-in-out group-hover:!text-hover-base-100-hover"
            color="text-base-100"
          >
            Total assets
          </Typography>
          <ChevronIcon className="size-4 text-base-100 transition-colors duration-200 ease-in-out group-hover:text-hover-base-100-hover" />
        </div>
        <Heading variant="s" tag="span" className="text-left">
          {balance}
        </Heading>
      </div>
      <img src={AllAccounts} alt="assets" className="h-14 w-14" />
    </div>
  );
};
export const AssetsWidget = () => {
  const [isTotalAssetsOpen, setIsTotalAssetsOpen] = useState(false);
  const [isAddAccountOpen, setIsAddAccountOpen] = useState(false);
  const accounts = useVabsAccountsStore((state) => state.accounts);
  const account = useAccountStore((state) => state.account);
  const balance = useTotalBalanceStore((state) => state.totalBalance);
  const filteredAccounts = accounts.filter((i) => i.status === 'ACTIVE');
  const handleOpenAddAccount = () => {
    setIsAddAccountOpen(true);
    setIsTotalAssetsOpen(false);
  };
  const accountsToShow =
    filteredAccounts.length > 3
      ? filteredAccounts.slice(0, 2)
      : filteredAccounts;

  const showOthers = filteredAccounts.length > 3;
  const showAddAccountButton = filteredAccounts.length < 3;

  const othersCount = filteredAccounts.length - accountsToShow.length;

  return (
    <div className="flex h-full w-full flex-col p-1">
      <TotalAssetsModal
        open={isTotalAssetsOpen}
        onAddAccount={handleOpenAddAccount}
        onOpenChange={setIsTotalAssetsOpen}
      >
        <AssetsWidgetHeader
          balance={`${balance?.amount || '0'} ${balance?.symbol || account?.symbol || ''}`}
          onClick={() => {
            setIsTotalAssetsOpen(true);
          }}
        />
      </TotalAssetsModal>
      <div className="mt-2 flex w-full flex-col gap-y-0.5">
        {accountsToShow.map((account) => (
          <AssetsItem account={account} key={account.id} />
        ))}
        {showOthers && (
          <TotalAssetsModal
            open={isTotalAssetsOpen}
            onAddAccount={handleOpenAddAccount}
            onOpenChange={setIsTotalAssetsOpen}
          >
            <OthersAssetsItem othersCount={othersCount} />
          </TotalAssetsModal>
        )}
      </div>
      <AddAccount
        open={isAddAccountOpen}
        onOpenChange={setIsAddAccountOpen}
        onConfirmAdding={() => {
          setIsAddAccountOpen(false);
        }}
      >
        <></>
      </AddAccount>
      {showAddAccountButton && (
        <Button
          variant="contrast-500"
          size="d-l"
          className="mt-auto w-full"
          onClick={() => {
            setIsAddAccountOpen(true);
          }}
        >
          + Add account
        </Button>
      )}
    </div>
  );
};
